module.exports = __webpack_public_path__ + "img/mark.9c27954e.png";